import { render } from "./LiquidacionInfo.vue?vue&type=template&id=33e266be&scoped=true"
import script from "./LiquidacionInfo.vue?vue&type=script&lang=js"
export * from "./LiquidacionInfo.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./LiquidacionInfo.vue?vue&type=style&index=1&id=33e266be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e266be"]])

export default __exports__